module.exports = __webpack_public_path__ + "img/title-@3x.04256816.png";